<template>
  <div></div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLoginStore } from '@/plugins/builtin'

const router = useRouter()
const userStore = useLoginStore()

const currentRoute = computed(() => router.currentRoute.value)
const state = computed(() => currentRoute.value.query.state as string)
const code = computed(() => currentRoute.value.query.code as string)

onMounted(async () => {

  const queryParams = {
    code: code.value
  }

  console.log(queryParams)

  userStore.signin('/v1/api/oauth2/third_parties/google/callback', queryParams)
})


</script>

<style scoped lang="less">
</style>
